<template>
	<div class="card">
		<div class="card-header">
			Data Presensi
			<el-tooltip placement="right" content="Lihat data presensi">
				<el-button link type="primary" tag="router-link" to="presensi">
					<el-icon><i class="bi bi-box-arrow-in-up-right"></i></el-icon>
				</el-button>
			</el-tooltip>
		</div>
		<div class="card-body row align-items-center" v-loading="loading">
			<span class="col-auto mx-auto" v-if="loading">Memuat...</span>
			<span class="col-auto mx-auto" v-else-if="!logCounts.length">Data tidak ditemukan</span>
			<el-descriptions :column="1" border v-else>
				<el-descriptions-item v-for="lc in logCounts" :key="`${lc.tahun}_${lc.bulan}`" :label="lc.bulan_tahun" label-align="right">
					<div class="hstack gap-1">
						<transition name="slide-up" mode="out-in">
							<span class="fs-5" :key="lc.jumlah">{{ lc.jumlah }}</span>
						</transition>
						<span>riwayat</span>
					</div>
				</el-descriptions-item>
			</el-descriptions>
		</div>
	</div>
</template>

<script>
export default {
	name: "DataPresensi",
	data() {
		return {
			logCounts: [],
			loading: true,
		};
	},
	mounted() {
		this.$ws.main.on("log:inserted", this.insertedLog);
		this.$ws.main.on("log:updated", this.updatedLog);
		this.$ws.main.on("log:deleted", this.deletedLog);
		this.getJumlahLogPresensi();
	},
	beforeUnmount() {
		this.$ws.main.off("log:inserted");
		this.$ws.main.off("log:updated");
		this.$ws.main.off("log:deleted");
	},
	methods: {
		toWIB(dateStr) {
			const d = new Date(dateStr);
			return new Date(d.getTime() + 7 * 60 * 60 * 1000);
		},
		insertedLog(data) {
			const newTanggal = this.toWIB(data.tanggal);
			const newTahun = newTanggal.getFullYear();
			const newBulan = newTanggal.getMonth() + 1;

			const existIndex = this.logCounts.findIndex((lc) => lc.tahun === newTahun && lc.bulan === newBulan);

			if (existIndex !== -1) {
				this.logCounts[existIndex].jumlah = this.logCounts[existIndex].jumlah + 1;

				return;
			}

			const temp = [...this.logCounts];

			const newData = {
				tahun: newTahun,
				bulan: newBulan,
				jumlah: 1,
				bulan_tahun: new Date(newTanggal).toLocaleDateString("id-ID", { month: "long", year: "numeric" }),
			};

			temp.push(newData);

			temp.sort((a, b) => {
				return b.tahun - a.tahun || b.bulan - a.bulan;
			});

			const newIndex = temp.findIndex((t) => t.tahun === newTahun && t.bulan === newBulan);

			if (newIndex === 12) return;

			this.logCounts.splice(newIndex, 0, newData);

			if (this.logCounts.length > 12) this.logCounts.pop();
		},
		updatedLog(data) {
			const oldTanggal = this.toWIB(data.old_log_presensi.tanggal);
			const newTanggal = this.toWIB(data.new_log_presensi.tanggal);

			if (oldTanggal.getMonth() === newTanggal.getMonth() && oldTanggal.getFullYear() === newTanggal.getFullYear()) return;

			const oldTahun = oldTanggal.getFullYear();
			const oldBulan = oldTanggal.getMonth() + 1;

			const oldIndex = this.logCounts.findIndex((lc) => lc.tahun === oldTahun && lc.bulan === oldBulan);

			if (oldIndex !== -1) {
				if (this.logCounts[oldIndex].jumlah === 1) this.logCounts.splice(oldIndex, 1);
				else this.logCounts[oldIndex].jumlah = this.logCounts[oldIndex].jumlah - 1;
			}

			const newTahun = newTanggal.getFullYear();
			const newBulan = newTanggal.getMonth() + 1;

			const newIndex = this.logCounts.findIndex((lc) => lc.tahun === newTahun && lc.bulan === newBulan);

			if (newIndex !== -1) {
				this.logCounts[newIndex].jumlah = this.logCounts[newIndex].jumlah + 1;
			} else {
				const temp = [...this.logCounts];

				const newData = {
					tahun: newTahun,
					bulan: newBulan,
					jumlah: 1,
					bulan_tahun: new Date(newTanggal).toLocaleDateString("id-ID", { month: "long", year: "numeric" }),
				};

				temp.push(newData);

				temp.sort((a, b) => {
					return b.tahun - a.tahun || b.bulan - a.bulan;
				});

				const newDataIndex = temp.findIndex((t) => t.tahun === newTahun && t.bulan === newBulan);

				if (newDataIndex === 12) return;

				this.logCounts.splice(newDataIndex, 0, newData);

				if (this.logCounts.length > 12) this.logCounts.pop();
			}
		},
		deletedLog(data) {
			const oldTanggal = this.toWIB(data.old_log_presensi.tanggal);
			const oldTahun = oldTanggal.getFullYear();
			const oldBulan = oldTanggal.getMonth() + 1;

			const existIndex = this.logCounts.findIndex((lc) => lc.tahun === oldTahun && lc.bulan === oldBulan);

			if (existIndex !== -1) {
				if (this.logCounts[existIndex].jumlah === 1) this.logCounts.splice(existIndex, 1);
				else this.logCounts[existIndex].jumlah = this.logCounts[existIndex].jumlah - 1;
			}
		},
		async getJumlahLogPresensi() {
			try {
				const { data } = await this.$defaultApi.get("/log/count/month");

				const logs = data.data.log_presensi_counts.map((l) => ({
					...l,
					bulan_tahun: new Date(l.tahun, l.bulan - 1, 1).toLocaleDateString("id-ID", { month: "long", year: "numeric" }),
				}));

				await new Promise((resolve) => setTimeout(resolve, 500));
				this.logCounts = logs;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>

<style scoped></style>
